export default __webpack_public_path__ + "static/media/dot_animated.ac46786d.svg";